module.exports = __webpack_public_path__ + "static/media/MLTool.1d50d1e1.svg";